import type { ReactNode } from "react";

export type NotificationTone = "default" | "error";
export interface NotificationEvent {
  message: string;
  tone: NotificationTone;
  id?: string;
  content?: ReactNode;
  action?: ReactNode;
  onDismiss?: () => void;
  dismissed?: boolean;
}

const listeners = new Set<(event: NotificationEvent) => void>();
export const enqueueNotification = (current: NotificationEvent[], next: NotificationEvent): NotificationEvent[] => {
  if (next.dismissed) return current.filter((item) => item.id !== next.id);
  if (next.id && current.some((item) => item.id === next.id))
    return current.map((item) => (item.id === next.id ? next : item));
  return current.some((item) => item.message === next.message && item.tone === next.tone)
    ? current
    : [...current, next];
};
export const publishNotice = (event: NotificationEvent): void => {
  listeners.forEach((listener) => listener(event));
};
export const dismissNotice = (id: string): void => publishNotice({ id, message: "", tone: "default", dismissed: true });
let last: { key: string; at: number } | null = null;

export const publishNotification = (message: string, tone: NotificationTone = "default"): void => {
  const key = `${tone}:${message}`;
  const now = Date.now();
  if (last?.key === key && now - last.at < 1_000) return;
  last = { key, at: now };
  const event = { message, tone };
  listeners.forEach((listener) => listener(event));
};

export const subscribeNotifications = (listener: (event: NotificationEvent) => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
